/** Lower-cased, accents stripped and trimmed, so "québec" finds "Quebec" and "  RBC" finds "RBC". */
export function normalizeForSearch(text: string): string {
  return text.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();
}

/** Substring match on the display label; an empty query matches everything. */
export function matchesQuery(label: string, query: string): boolean {
  const needle = normalizeForSearch(query);
  return needle.length === 0 || normalizeForSearch(label).includes(needle);
}
